import { useTurl } from "~/util/Lang";
import css from "./Inventory.module.css";
import { Icon24 } from "../ui/Icon";
import { Link } from "react-router";
import { useState } from 'react';

type Item = {
  id: number;
  itemName: string;
  type: string;
  name: string;
  icon: string;
};

type ItemSlot = {
  count: number;
  item: Item;
};

export function Inventory(params: { data: ItemSlot[]; height?: number | string; title: string; }) {
  const { data, height, title } = params;
  const [filter, setFilter] = useState('');
  return (
    <div className={css.root}>
      <div className={css.title}>{title}</div>
      <input className={css.input} value={filter} onChange={e => setFilter(e.target.value)} autoComplete='off' placeholder='Search Item' />
      <ul style={{ height: height ?? 400 }}>
        {data.filter(f => f.item.name.toLocaleLowerCase().includes(filter.toLocaleLowerCase()) || filter === '').map((item, i) => (
          <Item key={i} data={item} />
        ))}
      </ul>
    </div>
  );
}

function Item(params: { data: ItemSlot; }) {
  const { count, item } = params.data;
  const turl = useTurl();
  return item ? (
    <li className={css.item}>
      <Icon24 icon={item.icon} />
      <div className={css.itemName}>
        <Link to={turl(`/items/${item.itemName}`)}>{item.name}</Link>
        {item.type === "questitem" ? (
          <span style={{ fontSize: 12 }}>[Quest]</span>
        ) : null}
      </div>
      <div className={css.count}>{`x${count}`}</div>
    </li>
  ) : (
    <div>juy</div>
  );
}
